const en = {
  dailyDriver_title: 'Daily Agent service — customer billing',
  dailyDriver_description:
    'Service-date workload. Offers follow their Agent; Trip metrics and customer billing follow the current persisted assignee. Not Agent payout or historical driving segments.',
  dailyDriver_dateBasis: 'Service date: scheduled start, otherwise Trip creation (Bangkok)',
  dailyDriver_source_current:
    'Current master identity and persisted Trip assignee as of snapshot; completed counts require persisted completion evidence.',
  dailyDriver_source_offers:
    'Persisted offers linked to the service-date cohort; accepted assignment evidence includes recorded assignments.',
  dailyDriver_source_finance:
    'Canonical one-row-per-Trip customer finance attributed once to its current assignee; THB. Not payout; no notional fare reconstruction.',
  dailyDriver_source_mapping:
    'Distinct union of current service-group area mappings, not historical assignment scope.',
  dailyDriver_empty_unknown:
    'Unavailable. Metrics are null when assigned Trips exist but no value is known; zero when no Trip is attributed. Coverage counts accompany partial sums. Agent code is not persisted.',
  dailyDriver_empty_zero: 'Zero means no matching facts; known coverage counts distinguish missing metrics.',
  dailyDriver_empty_none: 'No recorded value or no current scope mapping.',
  dailyDriver_serviceMode: 'Service mode',
  dailyDriver_isFree: 'Free service',
  dailyDriver_agentIds: 'Agent IDs',
  dailyDriver_RIDE: 'Ride',
  dailyDriver_CARE: 'Care',
  dailyDriver_RIDE_AND_CARE: 'Ride and care',
  dailyDriver_TRAVEL: 'Travel',
  dailyDriver_SERVICE_DATE: 'Service date',
  dailyDriver_CURRENT_SERVICE_GROUP: 'Current service-group mapping',
  dailyDriver_PERSISTED_TRIP_ASSIGNEE_AS_OF: 'Current persisted assignee at snapshot',
  dailyDriver_agentCount: 'Distinct Agents',
  dailyDriver_unassignedTripCount: 'Excluded unassigned Trips',
  dailyDriver_unassignedBilledTotal: 'Excluded unassigned customer billed total',
  dailyDriver_provider_id: 'Provider ID',
  dailyDriver_provider_code: 'Provider code',
  dailyDriver_provider_name: 'Provider',
  dailyDriver_business_date: 'Service date',
  dailyDriver_date_basis: 'Date basis',
  dailyDriver_agent_id: 'Agent ID',
  dailyDriver_agent_code: 'Agent code',
  dailyDriver_agent_name: 'Agent',
  dailyDriver_agent_phone: 'Agent phone',
  dailyDriver_service_area_ids: 'Area IDs',
  dailyDriver_service_area_names: 'Areas',
  dailyDriver_service_group_ids: 'Group IDs',
  dailyDriver_service_group_names: 'Groups',
  dailyDriver_scope_provenance: 'Scope provenance',
  dailyDriver_attributed_trip_count: 'Current-assignee trips',
  dailyDriver_assignment_evidence_trip_count: 'Distinct assignment-evidence trips',
  dailyDriver_completed_trip_count: 'Completed-evidence trips',
  dailyDriver_cancelled_trip_count: 'Cancelled trips',
  dailyDriver_missed_trip_count: 'Missed trips',
  dailyDriver_offers_count: 'Offers',
  dailyDriver_accepted_offer_count: 'Accepted offers',
  dailyDriver_rejected_offer_count: 'Rejected offers',
  dailyDriver_expired_offer_count: 'Expired offers',
  dailyDriver_superseded_offer_count: 'Superseded offers',
  dailyDriver_cancelled_offer_count: 'Cancelled offers',
  dailyDriver_pending_offer_count: 'Pending offers',
  dailyDriver_planned_distance_km_sum: 'Planned distance (km) sum',
  dailyDriver_planned_distance_known_trip_count: 'Planned distance (km) known trips',
  dailyDriver_actual_distance_km_sum: 'Actual distance (km) sum',
  dailyDriver_actual_distance_known_trip_count: 'Actual distance (km) known trips',
  dailyDriver_planned_duration_min_sum: 'Planned duration (minutes) sum',
  dailyDriver_planned_duration_known_trip_count: 'Planned duration (minutes) known trips',
  dailyDriver_actual_duration_min_sum: 'Actual duration (minutes) sum',
  dailyDriver_actual_duration_known_trip_count: 'Actual duration (minutes) known trips',
  dailyDriver_attribution_basis: 'Billing attribution basis',
  dailyDriver_currency: 'Currency',
  dailyDriver_fare_total_sum: 'Customer fare total',
  dailyDriver_billed_total_sum: 'Customer billed total',
  dailyDriver_received_total_sum: 'Customer received total',
  dailyDriver_outstanding_total_sum: 'Customer outstanding total',
  dailyDriver_free_trip_count: 'Free trips',
  dailyDriver_finance_review_count: 'Customer finance review trips',
  dailyDriver_meaning_attributed:
    'Distinct cohort Trips currently assigned to this Agent. Customer billing and whole-Trip metrics are attributed once as of snapshot, not Agent payout or historical driving segments.',
  dailyDriver_meaning_evidence:
    'Distinct cohort Trips with an accepted offer or recorded ASSIGNED/REASSIGNED evidence for this Agent. Reassignment can count the same Trip for multiple Agents; the grand total is distinct again, not a row sum.',
  dailyDriver_meaning_completed:
    'Current-attributed Trips with recorded COMPLETED evidence, not inferred from terminal status alone.',
  dailyDriver_meaning_terminal:
    'Current-attributed Trips whose persisted current status is CANCELLED or MISSED respectively. Milestone counts may overlap terminal outcomes.',
  dailyDriver_meaning_metrics:
    'Sum of known persisted whole-Trip metrics for the current assignee; known-trip counts measure partial coverage. No actual/planned substitution and no split across historical assignees. All missing with attributed Trips means null; no attributed Trips means zero.',
  dailyDriver_totalRows: 'Provider-day-Agent rows',
  dailyDriver_unassignedReceivedTotal: 'Excluded unassigned customer received total',
  dailyDriver_unassignedOutstandingTotal: 'Excluded unassigned customer outstanding total',
  dailyDriver_unassignedMissingFareCount: 'Excluded unassigned missing-fare Trips',
  dailyDriver_missing_fare_count: 'Missing-fare trips',
} as const;
const th = {
  dailyDriver_title: 'งานบริการรายวันของพนักงาน — ยอดลูกค้า',
  dailyDriver_description:
    'ภาระงานตามวันบริการ ข้อเสนอนับตามพนักงานที่ได้รับ งานและยอดลูกค้านับตามผู้รับมอบหมายปัจจุบัน ไม่ใช่ค่าตอบแทนหรือประวัติระยะทางที่พนักงานขับ',
  dailyDriver_dateBasis: 'วันบริการ: เวลาเริ่มตามกำหนด หรือเวลาสร้างงาน (กรุงเทพฯ)',
  dailyDriver_source_current: 'ข้อมูลบุคคลปัจจุบันและผู้รับมอบหมายงาน ณ เวลารายงาน จำนวนงานเสร็จต้องมีหลักฐานเสร็จสิ้น',
  dailyDriver_source_offers: 'ข้อเสนอที่บันทึกไว้ของงานในวันบริการ หลักฐานรับมอบหมายรวมเหตุการณ์มอบหมายที่บันทึกไว้',
  dailyDriver_source_finance:
    'ยอดลูกค้าจากข้อมูลการเงินมาตรฐานหนึ่งแถวต่องาน ระบุให้ผู้รับมอบหมายปัจจุบันครั้งเดียว หน่วยบาท ไม่ใช่ค่าตอบแทนและไม่สร้างราคาสมมติย้อนหลัง',
  dailyDriver_source_mapping: 'รายการไม่ซ้ำจากพื้นที่ของกลุ่มบริการปัจจุบัน ไม่ใช่ขอบเขตมอบหมายในอดีต',
  dailyDriver_empty_unknown:
    'ไม่มีข้อมูล เมื่องานที่ระบุผู้รับมอบหมายไม่มีค่าที่ทราบ ผลรวมเป็นค่าว่าง หากไม่มีงานผลรวมเป็นศูนย์ จำนวนงานที่ทราบค่าระบุความครอบคลุม ยังไม่มีรหัสพนักงานที่บันทึก',
  dailyDriver_empty_zero: 'ศูนย์หมายถึงไม่มีข้อมูลตรงเงื่อนไข จำนวนงานที่ทราบค่าแยกข้อมูลที่ขาดหาย',
  dailyDriver_empty_none: 'ไม่มีค่าบันทึกหรือไม่มีการผูกขอบเขตปัจจุบัน',
  dailyDriver_serviceMode: 'รูปแบบบริการ',
  dailyDriver_isFree: 'บริการฟรี',
  dailyDriver_agentIds: 'รหัสพนักงาน',
  dailyDriver_RIDE: 'รับส่ง',
  dailyDriver_CARE: 'ดูแล',
  dailyDriver_RIDE_AND_CARE: 'รับส่งและดูแล',
  dailyDriver_TRAVEL: 'เดินทาง',
  dailyDriver_SERVICE_DATE: 'วันบริการ',
  dailyDriver_CURRENT_SERVICE_GROUP: 'ขอบเขตกลุ่มบริการปัจจุบัน',
  dailyDriver_PERSISTED_TRIP_ASSIGNEE_AS_OF: 'ผู้รับมอบหมายที่บันทึก ณ เวลารายงาน',
  dailyDriver_agentCount: 'พนักงานไม่ซ้ำ',
  dailyDriver_unassignedTripCount: 'งานไม่มีผู้รับมอบหมายที่ไม่รวมในแถว',
  dailyDriver_unassignedBilledTotal: 'ยอดเรียกเก็บลูกค้าของงานไม่มีผู้รับมอบหมาย',
  dailyDriver_provider_id: 'รหัสผู้ให้บริการ',
  dailyDriver_provider_code: 'รหัสผู้ให้บริการ',
  dailyDriver_provider_name: 'ผู้ให้บริการ',
  dailyDriver_business_date: 'วันที่บริการ',
  dailyDriver_date_basis: 'เกณฑ์วันที่',
  dailyDriver_agent_id: 'รหัสพนักงาน',
  dailyDriver_agent_code: 'รหัสพนักงาน (ยังไม่บันทึก)',
  dailyDriver_agent_name: 'พนักงาน',
  dailyDriver_agent_phone: 'โทรศัพท์พนักงาน',
  dailyDriver_service_area_ids: 'รหัสพื้นที่',
  dailyDriver_service_area_names: 'พื้นที่',
  dailyDriver_service_group_ids: 'รหัสกลุ่มบริการ',
  dailyDriver_service_group_names: 'กลุ่มบริการ',
  dailyDriver_scope_provenance: 'ที่มาขอบเขต',
  dailyDriver_attributed_trip_count: 'งานของผู้รับมอบหมายปัจจุบัน',
  dailyDriver_assignment_evidence_trip_count: 'งานที่มีหลักฐานรับมอบหมาย',
  dailyDriver_completed_trip_count: 'งานที่มีหลักฐานเสร็จสิ้น',
  dailyDriver_cancelled_trip_count: 'งานยกเลิก',
  dailyDriver_missed_trip_count: 'งานพลาดบริการ',
  dailyDriver_offers_count: 'ข้อเสนองาน',
  dailyDriver_accepted_offer_count: 'ข้อเสนอที่รับ',
  dailyDriver_rejected_offer_count: 'ข้อเสนอที่ปฏิเสธ',
  dailyDriver_expired_offer_count: 'ข้อเสนอหมดอายุ',
  dailyDriver_superseded_offer_count: 'ข้อเสนอถูกแทนที่',
  dailyDriver_cancelled_offer_count: 'ข้อเสนอยกเลิก',
  dailyDriver_pending_offer_count: 'ข้อเสนอรอรับ',
  dailyDriver_planned_distance_km_sum: 'ระยะทางตามแผน (กม.) รวม',
  dailyDriver_planned_distance_known_trip_count: 'ระยะทางตามแผน (กม.) งานที่ทราบค่า',
  dailyDriver_actual_distance_km_sum: 'ระยะทางจริง (กม.) รวม',
  dailyDriver_actual_distance_known_trip_count: 'ระยะทางจริง (กม.) งานที่ทราบค่า',
  dailyDriver_planned_duration_min_sum: 'เวลาตามแผน (นาที) รวม',
  dailyDriver_planned_duration_known_trip_count: 'เวลาตามแผน (นาที) งานที่ทราบค่า',
  dailyDriver_actual_duration_min_sum: 'เวลาจริง (นาที) รวม',
  dailyDriver_actual_duration_known_trip_count: 'เวลาจริง (นาที) งานที่ทราบค่า',
  dailyDriver_attribution_basis: 'เกณฑ์ระบุผู้รับมอบหมายเพื่อยอดลูกค้า',
  dailyDriver_currency: 'สกุลเงิน',
  dailyDriver_fare_total_sum: 'รวมค่าโดยสารลูกค้า',
  dailyDriver_billed_total_sum: 'รวมยอดเรียกเก็บลูกค้า',
  dailyDriver_received_total_sum: 'รวมยอดรับจากลูกค้า',
  dailyDriver_outstanding_total_sum: 'รวมยอดค้างชำระลูกค้า',
  dailyDriver_free_trip_count: 'งานฟรี',
  dailyDriver_finance_review_count: 'งานที่ต้องตรวจสอบยอดลูกค้า',
  dailyDriver_meaning_attributed:
    'งานในชุดวันบริการที่ระบุให้พนักงานนี้ปัจจุบันไม่ซ้ำ ยอดลูกค้าและค่ารวมทั้งงานระบุครั้งเดียว ณ เวลารายงาน ไม่ใช่ค่าตอบแทนหรือระยะทางตามช่วงผู้ขับในอดีต',
  dailyDriver_meaning_evidence:
    'งานไม่ซ้ำที่มีข้อเสนอรับแล้วหรือหลักฐาน ASSIGNED/REASSIGNED ของพนักงานนี้ การมอบหมายใหม่อาจนับงานเดียวให้หลายคน ยอดรวมจึงนับงานไม่ซ้ำใหม่ ไม่บวกแถว',
  dailyDriver_meaning_completed: 'งานของผู้รับมอบหมายปัจจุบันที่มีหลักฐาน COMPLETED ไม่อนุมานจากสถานะสิ้นสุดอย่างเดียว',
  dailyDriver_meaning_terminal:
    'งานของผู้รับมอบหมายปัจจุบันที่มีสถานะ CANCELLED หรือ MISSED ตามลำดับ จำนวนหลักฐานรับงานหรือเสร็จสิ้นอาจซ้อนกับผลลัพธ์สิ้นสุด',
  dailyDriver_meaning_metrics:
    'รวมค่าที่บันทึกและทราบของทั้งงานให้ผู้รับมอบหมายปัจจุบัน จำนวนงานที่ทราบค่าระบุความครอบคลุม ไม่แทนค่าจริงด้วยค่าตามแผนหรือแบ่งให้ผู้รับมอบหมายในอดีต หากมีงานแต่ไม่ทราบทุกค่าผลรวมเป็นค่าว่าง หากไม่มีงานเป็นศูนย์',
  dailyDriver_totalRows: 'แถวผู้ให้บริการ-วัน-พนักงาน',
  dailyDriver_unassignedReceivedTotal: 'ยอดรับจากลูกค้าของงานไม่มีผู้รับมอบหมายที่ไม่รวม',
  dailyDriver_unassignedOutstandingTotal: 'ยอดค้างลูกค้าของงานไม่มีผู้รับมอบหมายที่ไม่รวม',
  dailyDriver_unassignedMissingFareCount: 'งานไม่มีผู้รับมอบหมายและไม่มีค่าโดยสารที่ไม่รวม',
  dailyDriver_missing_fare_count: 'งานไม่มีค่าโดยสาร',
} satisfies Record<keyof typeof en, string>;
export const dailyDriverServiceTranslations = { th, en };
